import React, { useState } from "react";
import { X } from "lucide-react";

const HowToPlayModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="text-center">
        <button
          onClick={() => setIsOpen(true)}
          className="px-4 py-2 mt-2 rounded-full text-sm font-semibold active:scale-95 transition-transform"
          style={{
            background: "rgba(249,168,212,0.15)",
            color: "#b06ab3",
            border: "1.5px solid #f9a8d4",
          }}
        >
          ¿No sabes qué hacer? Te cuento
        </button>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 font-quicksand">
          <div
            className="p-7 max-w-md mx-4 relative"
            style={{
              background: "white",
              borderRadius: "20px",
              border: "2px solid #f9a8d4",
              boxShadow: "0 8px 32px rgba(176,106,179,0.15)",
            }}
          >
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-3 hover:scale-110 transition-transform"
              style={{ color: "#c4b5fd" }}
            >
              <X size={20} />
            </button>

            <div className="text-center mb-6">
              <h3
                className="text-lg font-bold mb-4"
                style={{ color: "#b06ab3" }}
              >
                ¿Cómo se juega?
              </h3>
              <p className="mb-4 text-sm" style={{ color: "#6b7280" }}>
                Completa frases icónicas de Karime según tu mood. Entre más
                perrísima te pongas, más palabras faltan.
              </p>
              <ul
                className="text-left list-disc list-inside text-sm mb-4 space-y-1"
                style={{ color: "#6b7280" }}
              >
                <li>
                  <strong style={{ color: "#2d1f3d" }}>💛 Cute:</strong> Falta
                  solo 1 palabra.
                </li>
                <li>
                  <strong style={{ color: "#2d1f3d" }}>💜 Coquetona:</strong>{" "}
                  Faltan 2 seguidas.
                </li>
                <li>
                  <strong style={{ color: "#2d1f3d" }}>❤️ Perrísima:</strong>{" "}
                  Faltan 3 palabras clave. 🔥
                </li>
              </ul>
              <p className="text-sm" style={{ color: "#6b7280" }}>
                💥 Bonus si escribes la frase completa o si contestas
                rapidísimo.
              </p>
            </div>

            <div className="flex justify-center">
              <button
                onClick={() => setIsOpen(false)}
                className="px-5 py-2 bg-custom-blue text-white rounded-full active:scale-95 transition-transform"
                style={{ boxShadow: "0 4px 12px rgba(125,211,252,0.4)" }}
              >
                ¡Entendido!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HowToPlayModal;
